<template>
	<section>
		<!--Card Wrap-->
		<section class="card section_pad">
			<div class="row">
				<div class="layout">

					<!--Sidebar-->
					<aside class="sidebar layout__sidebar">

						<!--Sidebar Avatar-->
						<div class="sidebar__avatar-wrap">
							<user-avatar :data="patient" :setClass="'sidebar__avatar user_fix'"></user-avatar>
						</div>
						<!--Sidebar Avatar End-->

						<!--Sidebar Button-->
						<div class="sidebar__bnt-wrap">
							<button class="sidebar__btn card__sidebar-btn" @click="finishVisit"
											v-if="visit._id && visit.status === 'came'">Завершить визит
							</button>
						</div>
						<!--Sidebar Вutton End-->

						<!--Sidebar Menu-->
						<nav class="sidebar__menu">
							<ul class="sidebar__list">
								<li class="sidebar__list-item">
									<a href="#" class="sidebar__link"> - Основное</a>
								</li>
								<li class="sidebar__list-item">
									<a class="sidebar__link not-ready"> - Мед. карта</a>
								</li>
								<li class="sidebar__list-item">
									<a class="sidebar__link not-ready"> - Стомат. карта</a>
								</li>
								<li class="sidebar__list-item">
									<a class="sidebar__link not-ready"> - Показатели</a>
								</li>
								<li class="sidebar__list-item">
									<a class="sidebar__link not-ready"> - Дневник</a>
								</li>
								<li class="sidebar__list-item">
									<a class="sidebar__link not-ready"> - Доступы</a>
								</li>

							</ul>
						</nav>
						<!--Sidebar Menu End-->

					</aside>
					<!--Sidebar End-->

					<!--Card content-->
					<div class="layout__box">
						<div class="card-line" v-show="visit.status === 'came'">Идет прием</div>

						<!--Sidebar Вutton-->
						<div class="sidebar__bnt-wrap under_visit_status">
							<button class="sidebar__btn card__sidebar-btn" @click="finishVisit"
											v-if="visit._id && visit.status === 'came'">Завершить визит
							</button>
						</div>
						<!--Sidebar Вutton End-->
						<!-- Row -->
						<div class="row">
							<!-- Column -->
							<div class="columns small-12 medium-12 large-12">
								<!-- Basic Widget -->
								<form id="baseInfo">
								<div class="basic-widget">
									<div class="basic-widget__header">
										<p class="basic-widget__title">Личная информация</p>
<!--										<i class="basic-icon basic-widget__icon icon ion-edit trans"></i>-->
										<i id="saveBaseInfo" class="basic-icon basic-widget__icon icon trans" @click="editBaseInfo(patient._id)" v-show="statusEditing && isCanWrite">Сохранить</i>
										<i id="editBaseInfo" class="basic-icon basic-widget__icon icon  trans" @click="startEditBaseInfo()" v-show="!statusEditing && isCanWrite">Изменить</i>
									</div>
									<div class="basic-widget__inner">
										<div class="row">
											<div class="columns small-12 medium-6 large-6">
												<!-- Basic List -->
												
												<ul class="basic-list card__basic-list">
													<li class="basic-list-item">
														<label for="last_name" class="span-text span-text_label t-right">Фамилия:</label>
														<input id="" class="span-text span-text_value t-left" v-model="patient.last_name" readonly>
													</li>
													<li class="basic-list-item">
														<label class="span-text span-text_label t-right">Имя:</label>
														<input id="" class="span-text span-text_value t-left" v-model="patient.first_name" readonly>
													</li>
													<li class="basic-list-item">
														<label class="span-text span-text_label t-right">Отчество:</label>
														<input id="" class="span-text span-text_value t-left" v-model="patient.middle_name" readonly>
													</li>
													<li class="basic-list-item">
														<label class="span-text span-text_label t-right">Дата рождения:</label>
														<input id="" class="span-text span-text_value t-left" v-model="patient.birthday" v-mask="'##-##-####'" readonly>
													</li>
													<li class="basic-list-item">
														<label class="span-text span-text_label t-right">Пол:</label>
														<span class="t-right">
														    <label for="male">Муж </label>
                                                            <input type="radio" id="male" value="male" v-model="patient.sex" readonly> 
                                                            <input type="radio" id="female" value="female" v-model="patient.sex" readonly>
                                                            <label for="female"> Жен</label>
														</span>
													</li>
													<li class="basic-list-item">
														<label class="span-text span-text_label t-right">Телефон:</label>
														<input id="phone" type="number" class="span-text span-text_value t-left" v-show="patient.phone" v-model="patient.phone" readonly>
													</li>
													<!--<li class="basic-list-item">-->
													<!--<span class="span-text span-text_label t-right">Группа крови:</span>-->
													<!--<input id="" class="span-text span-text_value t-left" value="">А(II) Rh+</span>-->
													<!-- //TODO Вставить настоящую группу -->
													<!--</li>-->
												</ul>
												<!-- Basic List End -->
                                            
											</div>
											<div class="columns small-12 medium-6 large-6">
												<!-- Basic List -->
												<ul class="basic-list">
													<li class="basic-list-item">
														<span class="span-text span-text_label t-right">Страна:</span>
														<input id="" class="span-text span-text_value t-left"  v-model="patient.country" readonly>
														
													</li>
													<li class="basic-list-item">
														<span class="span-text span-text_label t-right">Область:</span>
														<input id="" class="span-text span-text_value t-left"  v-model="patient.region" readonly>
														
													</li>
													<li class="basic-list-item">
														<span class="span-text span-text_label t-right">Город:</span>
														<input id="" class="span-text span-text_value t-left"  v-model="patient.city" readonly>
														
													</li>
													<li class="basic-list-item">
														<span class="span-text span-text_label t-right">Улица:</span>
														<input id="" class="span-text span-text_value t-left"  v-model="patient.street" readonly>
														
													</li>
													<li class="basic-list-item">
														<span class="span-text span-text_label t-right">Дом:</span>
														<input id="" class="span-text span-text_value t-left"  v-model="patient.house" readonly>
														
													</li>
													<li class="basic-list-item">
														<span class="span-text span-text_label t-right">Квартира:</span>
														<input id="" class="span-text span-text_value t-left"  v-model="patient.apartment" readonly>
														
													</li>
												</ul>
												<!-- Basic List End -->
											</div>
										</div>
									</div>
								</div>
								</form>
								<!-- Basic Widget End -->
							</div>
							<!-- Column End -->

							<!-- Column -->
							<div class="columns small-12 medium-12 large-12 not-ready">
								<!-- Basic Widget -->
								<div class="basic-widget">
									<div class="basic-widget__header">
										<p class="basic-widget__title">Заболевания под наблюдением</p>
										<i class="basic-icon basic-widget__icon icon ion-plus trans"></i>
									</div>
									<div class="basic-widget__inner">
										<!-- Table -->
										<table class="basic-table">
											<!-- Row -->
											<tr class="basic-table__row hr">
												<th class="basic-table__title">Дата начала наблюдения</th>
												<th class="basic-table__title">Дата снятия с наблюдения</th>
												<th class="basic-table__title">Диагноз</th>
												<th class="basic-table__title">Код по МБК-10</th>
												<th class="basic-table__title">Доктор</th>
											</tr>
											<!-- Row End -->

											<!-- Row -->
											<tr class="basic-table__row hr">
												<td class="basic-table__cell card__table-cell_date">12.05.2009</td>
												<td class="basic-table__cell card__table-cell_date">03.07.2013</td>
												<td class="basic-table__cell">Хронеческая почечная недостаточность III</td>
												<td class="basic-table__cell">N03</td>
												<td class="basic-table__cell">Нучурниенко В.И.</td>
												<td class="basic-table__cell">
													<div class="basic-icon-wrap basic-icon-wrap_info">
														<i class="basic-icon_info fa fa-exclamation-circle" aria-hidden="true"></i>
													</div>
												</td>
											</tr>
											<!-- Row End -->

											<!-- Row -->
											<tr class="basic-table__row hr">
												<td class="basic-table__cell card__table-cell_date">12.05.2009</td>
												<td class="basic-table__cell card__table-cell_date">03.07.2013</td>
												<td class="basic-table__cell">Хронеческая почечная недостаточность III</td>
												<td class="basic-table__cell">N03</td>
												<td class="basic-table__cell">Нучурниенко В.И.</td>
												<td class="basic-table__cell">
													<div class="basic-icon-wrap basic-icon-wrap_info">
														<i class="basic-icon_info fa fa-exclamation-circle" aria-hidden="true"></i>
													</div>
												</td>
											</tr>
											<!-- Row End -->

											<!-- Row -->
											<tr class="basic-table__row hr">
												<td class="basic-table__cell card__table-cell_date">12.05.2009</td>
												<td class="basic-table__cell card__table-cell_date">03.07.2013</td>
												<td class="basic-table__cell">Хронеческая почечная недостаточность III</td>
												<td class="basic-table__cell card__table-cell_code">N03</td>
												<td class="basic-table__cell">Нучурниенко В.И.</td>
												<td class="basic-table__cell">
													<div class="basic-icon-wrap basic-icon-wrap_info">
														<i class="basic-icon_info fa fa-exclamation-circle" aria-hidden="true"></i>
													</div>
												</td>
											</tr>
											<!-- Row End -->

										</table>
										<!-- Table End -->
									</div>
								</div>
								<!-- Basic Widget End -->
							</div>
							<!-- Column End -->

							<!-- Column -->
							<div class="columns small-12 medium-6 large-6 not-ready">
								<!-- Basic Widget -->
								<div class="basic-widget">
									<div class="basic-widget__header">
										<p class="basic-widget__title">Алергии</p>
										<i class="basic-icon basic-widget__icon icon ion-plus trans"></i>
									</div>
									<div class="basic-widget__inner">
										<!-- Table -->
										<table class="basic-table">

											<!-- Row -->
											<tr class="basic-table__row hr">
												<td class="basic-table__cell">Молоко</td>
												<td class="basic-table__cell">Хронеческая почечная недостаточность III</td>
												<td class="basic-table__cell">
													<div class="basic-icon-wrap basic-icon-wrap_info">
														<i class="basic-icon_info fa fa-exclamation-circle" aria-hidden="true"></i>
													</div>
												</td>
											</tr>
											<!-- Row End -->

											<!-- Row -->
											<tr class="basic-table__row hr">
												<td class="basic-table__cell">Молоко</td>
												<td class="basic-table__cell">Хронеческая почечная недостаточность III</td>
												<td class="basic-table__cell">
													<div class="basic-icon-wrap basic-icon-wrap_info">
														<i class="basic-icon_info fa fa-exclamation-circle" aria-hidden="true"></i>
													</div>
												</td>
											</tr>
											<!-- Row End -->

										</table>
										<!-- Table End -->
									</div>
								</div>
								<!-- Basic Widget End -->
							</div>
							<!-- Column End -->

							<!-- Column -->
							<div class="columns small-12 medium-6 large-6 not-ready">
								<!-- Basic Widget -->
								<div class="basic-widget">
									<div class="basic-widget__header">
										<p class="basic-widget__title">Алергии</p>
										<i class="basic-icon basic-widget__icon icon ion-plus trans"></i>
									</div>
									<div class="basic-widget__inner">
										<!-- Table -->
										<table class="basic-table">

											<!-- Row -->
											<tr class="basic-table__row hr">
												<td class="basic-table__cell">Молоко</td>
												<td class="basic-table__cell">Хронеческая почечная недостаточность III</td>
												<td class="basic-table__cell">
													<div class="basic-icon-wrap basic-icon-wrap_info">
														<i class="basic-icon_info fa fa-exclamation-circle" aria-hidden="true"></i>
													</div>
												</td>
											</tr>
											<!-- Row End -->

											<!-- Row -->
											<tr class="basic-table__row hr">
												<td class="basic-table__cell">Молоко</td>
												<td class="basic-table__cell">Хронеческая почечная недостаточность III</td>
												<td class="basic-table__cell">
													<div class="basic-icon-wrap basic-icon-wrap_info">
														<i class="basic-icon_info fa fa-exclamation-circle" aria-hidden="true"></i>
													</div>
												</td>
											</tr>
											<!-- Row End -->

										</table>
										<!-- Table End -->
									</div>
								</div>
								<!-- Basic Widget End -->
							</div>
							<!-- Column End -->

						</div>
						<!-- Row End -->


					</div>
					<!--Card content-->

				</div>
				<!--Card End-->

			</div>
			<!--Row End-->

		</section>
		<!--Card Wrap-->

	</section>
</template>

<script>
	import catalog from '@/components/forms.json'

	import formViewer from '@/components/FormViewer.vue'

	import Consultation from '@/components/Widgets/Consultation.vue'
	import Analysis from '@/components/Widgets/Analysis.vue'
	import FunctionalDiagnostics from '@/components/Widgets/FunctionalDiagnostics.vue'
	import BloodPressure from '@/components/Widgets/BloodPressure.vue'
	import Pulse from '@/components/Widgets/Pulse.vue'
	import BodyTemperature from '@/components/Widgets/BodyTemperature.vue'
	import BloodSugar from '@/components/Widgets/BloodSugar.vue'
	import Cholesterol from '@/components/Widgets/Cholesterol.vue'
	import Weight from '@/components/Widgets/Weight.vue'
	import Height from '@/components/Widgets/Height.vue'
	import DiseaseAccounting from '@/components/Widgets/DiseaseAccounting.vue'
	import Allergy from '@/components/Widgets/Allergy.vue'
	import Vaccination from '@/components/Widgets/Vaccination.vue'
    
    import moment from 'moment'
    import ChangeTime from "@/components/commonComponents/changeTime.vue"

	const hiddenKeys = ['_id', 'user', 'worker', 'created_at', 'updated_at', 'worker_id', 'user_id', 'type']

	export default {
		name: 'Card',
		components: {
			formViewer,
			Consultation,
			Analysis,
			FunctionalDiagnostics,
			BloodPressure,
			Pulse,
			BodyTemperature,
			BloodSugar,
			Cholesterol,
			Weight,
			Height,
			DiseaseAccounting,
			Allergy,
			Vaccination
		},
		computed: {
			userId() {
				return this.$route.params.id
			},
			workerId() {
				return this.$route.query.doctor
			},
            patientId() {
                return this.$route.query.patient
            },
			visitId() {
				return this.$route.query.visit
			},
			isVisit() {
				return !!this.$route.query.visit
			},
			isCanWrite() {
				return !this.isMyCard && this.hasAccess /*&& this.isVisit && this.visit.status === 'came'*/
			}
		},
		mounted () {
			this.$event.send('updateDayCount', 1)
			this.$event.send('updateEvents', this.$storage.get('worker'))

			this.catalog = catalog

			if (this.isVisit)
				this.getVisit(this.visitId)
			else
				this.getPatient(this.userId)

			this.getBaseInfo()
			this.checkAccess()
			this.getAccessList()
		},
		data () {
			return {
				card: {},
				baseInfo: {},
				visit: {},
				patient: {},
				sex: {
					male: 'М',
					female: "Ж"
				},
                //birthday: '',
				formsType: '',
				catalog: {},
				isFV: false,
				formObj: {},
				formRecord: {},
				accessList: {
					all: [],
					process: []
				},
				hasAccess: false,
				isMyCard: false,
                statusEditing: false,
			}
		},
		methods: {
			getBaseInfo() {
				this.$store.dispatch('card/getByType', {
					user_id: this.userId,
					worker_id: this.workerId,
					type: 'base_info'
				}).then(response => {
					this.baseInfo = response[0] || {}
				})
			},
			getVisit(id) {
				this.$store.dispatch('agenda/get', id).then(visit => {
					this.visit = visit || {}
					this.patient = visit.users[0] || {}
                    this.patient.birthday = moment(this.patient.birthday, 'X').format('DD-MM-YYYY')
					this.setAccessToCard(this.patient)
				})
			},
			getPatient(id) {
				this.$api.get('user/' + id).then(user => {
					this.patient = user || {}
					this.setAccessToCard(this.patient)
                    this.patient.birthday = moment(user.birthday, 'X').format('DD-MM-YYYY')
				})
			},
			getAccessList() {
				this.$api.post('access/list', {
					user_id: this.userId
				}).then(list => {
					list.data.map(item => {
						if (item.status === 'apply' || item.status === 'reject') {
							item.status = (item.status === 'apply')
							this.accessList.all.push(item)
						} else if (item.status === 'process') {
							this.accessList.process.push(item)
						}
					})
				})
			},
			checkAccess() {
				this.$api.get('access/has/' + this.workerId + '/' + this.patientId).then(response => {
					this.hasAccess = response.result
				})
			},
			updateField(type) {
				this.baseInfo.worker_id = this.workerId
				this.baseInfo.user_id = this.userId
				this.baseInfo.type = type

				this.$store.dispatch('card/update', this.baseInfo).then(response => {
					this.baseInfo = response[0]
				})
			},
			showForms(type) {
				this.formsType = type

				this.openTab(7)
			},
			selectForm(form) {
				this.formObj = form
				this.isFV = true

				this.openTab(8)
			},
			selectRecord(record) {
				this.formRecord = record

				this.openTab(9)
			},

			filterFields(object) {
				let result = {}

				for (let key in object) {
					if (object.hasOwnProperty(key) && hiddenKeys.indexOf(key) === -1) {
						result[key] = object[key]
					}
				}

				return result
			},
			requestAccessToCard(worker, user) {
				this.$api.post('access/', {
					worker_id: worker,
					user_id: user,
					status: 'process'
				}).then(() => {
					this.$event.toast('s', "Ваш запрос на доступ к карточке отправлен на рассмотрение")
				})
			},
			finishVisit() {
				this.$store.dispatch('agenda/update', {
					id: this.visit._id,
					status: "completed"
				}).then(() => {
					this.$router.go(-1)
				})
			},
			approveAccess(status, accessId, workerId, index) {
				if (!status || !accessId || !workerId)
					return false

				this.$api.put('access/' + accessId, {
					status: status,
					user_id: this.userId,
					worker_id: workerId
				}).then(response => {
					response.status = (response.status === 'apply')
					this.accessList.all.push(response)
					this.accessList.process.splice(index, 1)
				})
			},
			setAccess(bool, accessId, workerId) {
				if (!accessId || !workerId)
					return false

				this.$api.put('access/' + accessId, {
					status: (bool) ? 'apply' : 'reject',
					user: this.userId,
					worker: workerId
				})
			},
			setAccessToCard(patient) {
				this.isMyCard = (patient._id === this.$storage.get('user'))
			},
			openTab(number) {
				$('.Tabs-bar li').removeClass('active')
				$('.patient-card-info>div').removeClass('active')
				$('.patient-card-info>div[class=block-' + number + ']').addClass('active')
			},
            startEditBaseInfo() {
                this.statusEditing = true;
                var fields = document.querySelectorAll('#baseInfo .span-text_value');
                fields.forEach(function(item, i, fields) {
                    item.classList.add('span-text_value_edit');
                    item.removeAttribute('readonly');
                });
            },
            editBaseInfo(id) {
                this.$store.dispatch('user/update', {
                    id: id,
                    first_name: this.patient.first_name,
                    middle_name: this.patient.middle_name,
                    last_name: this.patient.last_name,
                    birthday: moment(this.patient.birthday, 'DD-MM-YYYY').format('X'),
                    sex: this.patient.sex,
                    phone: this.patient.phone,
                    country: this.patient.country,
                    region: this.patient.region,
                    city: this.patient.city,
                    streer: this.patient.street,
                    house: this.patient.house,
                    apartment: this.patient.apartment
                }).then(response => {
                    this.$event.toast('s', 'Информация сохранена успешно');
                    this.statusEditing = false;
                    var fields = document.querySelectorAll('#baseInfo .span-text_value');
                    console.log(fields);
                    fields.forEach(function(item, i, fields) {
                        item.classList.remove('span-text_value_edit');
                        item.setAttribute('readonly', 'readonly');
                    });
                })
            }
		}
	}
</script>

<style scoped>
	.patient-card-info .wg_title {
		margin: 0;
	}

	.patient-form-block label {
		width: 22%;
	}

	.under_visit_status {
		margin: 10px 0;
	}

	@media screen and (min-width: 768px) {
		.under_visit_status {
			display: none;
		}
	}
    .not-ready {
        opacity: 0.55;
        cursor: not-allowed;
    }
    .not-ready * {
        cursor: not-allowed;
    }
</style>



// WEBPACK FOOTER //
// Card.vue?534108b5